import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AuthService} from '../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime, filter, first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {PatientService} from '../../Services/patient.service';
import {ClientService} from '../../Services/client.service';
import {Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {parse, format, isValid} from 'date-fns';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {UserService} from '../../Services/UserService';
import {DatePipe} from '@angular/common';


interface patientDuplicatesPagination {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

interface filterParams {
  filterType: any;
  filterParam:any;
  startDate: any;
  endDate: any;
  wStartDate: any;
  wEndDate: any;
  planType: any;
  isMultipleFilter: boolean;
  userTimeZone: any;
  status: boolean;
  verification: any;
  sort: any;
  agent:any;
}

@Component({
  selector: 'pm-conflicted-accounts',
  templateUrl: './conflicted-accounts.component.html',
  styleUrls: ['./conflicted-accounts.component.css']
})

export class ConflictedAccountsComponent implements OnInit, AfterViewInit {

  tableData: any = [];
  assignArray: any = [];
  checked: boolean = false;
  agentArray: any = [];
  agent: any = null;
  totalRecord: any;
  // page:searchModel = new searchModel();
  pagination: patientDuplicatesPagination = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };
  filter: filterParams = {
    filterType:'initial',
    filterParam:null,
    startDate: null,
    endDate: null,
    wStartDate: null,
    wEndDate: null,
    planType: 'PPO',
    isMultipleFilter: true,
    userTimeZone: this.authService.getTimeZone(),
    status: true,
    verification: null,
    sort: null,
    agent: null
  };
  activeFilterType: string | null = null;
  activeFilterParams: any = null;
  sortDirection: 'asc' | 'desc' | null = null;
  sortField: string;
  searchString: any = null;
  searchPHolder: string = 'Search by name';
  button: string = 'Name';
  pBulkImport: FormGroup;
  files: File[] = [];
  isDragOver: boolean = false;
  fileImage: string | null = null; // Variable to hold the image URL
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  errorMessages: any;
  errorMessagePart: any;
  @ViewChild('fileDropRef') fileDropRef!: ElementRef;
  @ViewChild('searchBox') searchValue!: ElementRef;
  @ViewChild('bulkUpload') bulkUploadModal!: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('startDate', {static: true}) startDateInput: ElementRef;
  @ViewChild('endDate', {static: true}) endDateInput: ElementRef;
  @ViewChild('wstartDate', {static: true}) wstartDateInput: ElementRef;
  @ViewChild('wendDate', {static: true}) wendDateInput: ElementRef;
  searchText: string = '';
  search: string = '';
  filterAgentArray = [...this.agentArray];
  userId: any = null;
  agentId: any = null;
  meta: any;
  startDate: Date;
  endDate: Date;
  wstartDate: Date;
  wendDate: Date;
  minEndDate: Date | null = null; // Minimum date for End Date
  nameFilter: string;
  isDropdownOpen = false;
  status: string | null = null;
  toggleClicked: boolean = false;
  lStartDate: Date = new Date();
  lEndDate: Date = new Date();
  selectedPlanType : 'PPO' | 'HMO' = 'PPO';
  private clientSub: any;
  private subject: Subject<string> = new Subject();

  constructor(private fb: FormBuilder,
              private patientService: PatientService,
              private clientService: ClientService,
              public authService: AuthService,
              private userServices: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private dialog: MatDialog,
              private renderer: Renderer2,
              private datePipe: DatePipe,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {
    this._setSearchSubscription();
  }

  ngOnInit(): void {
    const saved = sessionStorage.getItem('patientDuplicateFilters');
    if (saved) {
      const parsed = JSON.parse(saved);
      this.filter = { ...this.filter, ...parsed };
    }

    // Sync UI toggle from filter (the thing your API uses)
    this.selectedPlanType = (this.filter.planType as 'PPO' | 'HMO') || 'PPO';
    this.getAgents();
    this.loadPaginationState(); // Remove pagination state on reload
    this._fetchData();
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this.pagination.page = 1;
        this.pagination.currentPage = 0;
        this._fetchData();
      }
    });

    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('patientDuplicatesPagination');
      sessionStorage.removeItem('patientDuplicateFilters');
    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
    }
  }

  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  formatStartOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }

  formatEndOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(23, 59, 59, 999);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }



  setFilterType(type: string , filterParam?: any) {
    this.filter.filterType = type ? type : null;
    this.filter.filterParam = filterParam?filterParam :null;
  }


  applyVerificationFilter(verification: string) {
    this.filter.verification = verification
    // You can add the logic here to filter based on the verification status
  }

  resetFilter(event?: MouseEvent) {
    if (event) {
      event.stopPropagation(); // Prevent the click from propagating to the dropdown
    }

    this.isDropdownOpen = false;
    this.toggleClicked = false;

    // 🔄 Reset all filters and state
    this.startDate = null;
    this.endDate = null;
    this.activeFilterType = null;
    this.activeFilterParams = null;
    this.wstartDate = null;
    this.wendDate = null;
    this.nameFilter = '';
    this.tableData = [];
    this.userId = null;
    this.agentId = null;

    // ✅ Reset filter to initial default state
    this.filter = {
      filterType: 'initial',
      filterParam:null,
      startDate: null,
      endDate: null,
      wStartDate: null,
      wEndDate: null,
      planType: 'PPO',
      isMultipleFilter: true,
      userTimeZone: this.authService.getTimeZone(),
      status: true,
      verification: null,
      sort: null,
      agent:null
    };

    this.pagination = {
      page: 1,         // API uses 1-based index
      size: 10,        // Default page size
      currentPage: 0
    }

    // 🧹 Clear session data
    sessionStorage.removeItem('patientDuplicateFilters');
    sessionStorage.removeItem('patientDuplicatesPagination');

    // 🔄 Refetch data with initial filter
    this._fetchData();
  }

  toggleFilter(type: string, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    switch (type) {
      case 'date':
        if (isChecked) {
          this.setFilterType('date');
        } else {
          this.filter.startDate = null;
          this.filter.endDate = null;
        }
        break;

      case 'wdate':
        if (isChecked) {
          this.setFilterType('wdate');
        } else {
          this.filter.wStartDate = null;
          this.filter.wEndDate = null;
        }
        break;

      case 'status':
        if (isChecked) {
          this.setFilterType(type);
        } else {
          // Disable that filter completely
          if (type === 'status') this.filter.status = null;
          this.filter.filterType = null;
        }
        break;

      case 'verification':
        if (isChecked) {
          this.setFilterType('verification');
        } else {
          this.filter.verification = null;
        }
        break;

      case 'agent':
        if (isChecked) {
          this.setFilterType('agent');
        } else {
          this.filter.agent = null;
        }
        break;
    }
  }

  toggleDropdown() {
    this.toggleClicked = !this.toggleClicked;
    this.isDropdownOpen = !this.isDropdownOpen;

    if (!this.isDropdownOpen) {
      this.resetFilter();
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    // Only proceed if dropdown is open
    if (this.isDropdownOpen) {
      const clickedInsideDropdown = this.dropdownContainer?.nativeElement.contains(targetElement);
      const clickedInsideDatepicker =
          this.startDateInput?.nativeElement.contains(targetElement) ||
          this.endDateInput?.nativeElement.contains(targetElement) ||
          this.wendDateInput?.nativeElement.contains(targetElement) ||
          this.wstartDateInput?.nativeElement.contains(targetElement);
      const clickedInsideCalendar = !!targetElement.closest('.bs-datepicker');

      // If click is outside everything (dropdown + datepickers)
      if (!clickedInsideDropdown && !clickedInsideDatepicker && !clickedInsideCalendar) {
        this.isDropdownOpen = false;
        this.toggleClicked = false; // 🔹 keep toggle state in sync

        // Reset filters only if none are active
        if (!this.filter.filterType) {
          this.startDate = null;
          this.endDate = null;
          this.wstartDate = null;
          this.wendDate = null;
          this.resetFilter();
        }
      }
    }
  }


  onFilteredReturn(filteredArray: any[]) {
    // Update the filterAgentArray based on the filtered results
    this.filterAgentArray = filteredArray;
  }

  getAgents() {
    let params = {
      isWorkOrderUser: true,
      clientId: this.authService.getClientId()
    };
    this.patientService.getAgents(params).pipe(first()).subscribe(
        (response: any) => {
          if (response) {
            this.agentArray = response;
            // Add `fullName` property to each agent in `agentArray`
            this.agentArray = this.agentArray.map(agent => ({
              ...agent,
              fullName: `${agent.firstName} ${agent.lastName}`
            }));

            // Initialize `filterAgentArray` with the updated `agentArray`
            this.filterAgentArray = [...this.agentArray];
            /* this.filterAgentArray = this.agentArray.filter(agent =>
                 `${agent.firstName} ${agent.lastName}`
                     .toLowerCase()
                     .includes(this.searchText.toLowerCase())
             );*/

          }
        });
  }
  getConflictAgentName(agentId: any): string {

    if (
      agentId === null ||
      agentId === undefined ||
      agentId === ''
    ) {
      return 'Select Agent';
    }

    const agent = this.agentArray?.find(
      (item: any) =>
        String(item.id) === String(agentId)
    );

    if (!agent) {
      return 'Select Agent';
    }

    return (
      agent.fullName ||
      `${agent.firstName || ''} ${agent.lastName || ''}`.trim() ||
      'Select Agent'
    );
  }  

  // clear the search in the dropdown select search input
  dropdownSearchClear(event: any) {
    event.target.value = null;
    setTimeout(() => {
      this.filterAgentArray = this.agentArray;
    }, 500);
  }

  onKeyUp(searchTextValue: any): void {
    this.subject.next(searchTextValue);
  }

  assign(id?: any) {
    if (id === 'All') {
      if (this.checked) {
        // Uncheck all items
        this.assignArray = []; // Clear assignArray
        this.tableData.forEach(item => {
          item.assigned = false; // Set assigned to false for all
          delete item.assignedF; // Remove the assignedF property
        });
        this.checked = false;
      } else {
        // Assign all items
        this.assignArray = this.tableData.map(item => item.id); // Update assignArray with all IDs
        this.tableData.forEach(item => {
          item.assigned = true; // Set assigned to true for all
          item.assignedF = true; // Add assignedF property
        });
        this.checked = true;
      }
    } else {
      const index = this.assignArray.indexOf(id);
      if (index === -1) {
        // Add ID if it's not in assignArray and set assigned to true
        this.assignArray.push(id);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = true;
          item.assignedF = true; // Add assignedF property to the specific item
        }
      } else {
        // Remove ID if it's already in assignArray
        this.assignArray.splice(index, 1);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = false;
          delete item.assignedF; // Remove the assignedF property from the specific item
        }
      }

      // Set checked to true only if all tableData IDs are in assignArray
      this.checked = this.tableData.every(item => this.assignArray.includes(item.id));
    }
  }

  assignAgent(isAssigned?: boolean) {
    if (this.assignArray.length !== 0) {
      // Conditionally create the params object
      let params: any = {};
      if (isAssigned) {
        params.userId = this.userId;
      }
      params.isAssigned = isAssigned;
      params.planType = 'PPO';

      let reqData = this.assignArray;
      this.patientService.assignPatient(reqData, params).pipe(first()).subscribe(
          (response: any) => {
            if (response != undefined) {
              this.refreshPatientListAfterAssignment();
              // this._fetchData();
              swal.fire({
                icon: 'success',
                text: 'Done',
                showConfirmButton: false,
                timer: 3000
              });
              this.userId = null;
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: response.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
      );
    } else {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: 'Please select at least one patient',
        showConfirmButton: false,
        timer: 5000
      });
      this.userId = null;
    }
  }

  refreshPatientListAfterAssignment() {
    if (this.activeFilterType === 'wdate' && this.activeFilterParams) {
      this.activeFilterParams.page = this.pagination.page;
      this.activeFilterParams.size = this.pagination.size;

      this.patientService.filterDateWOD(this.activeFilterParams).pipe(first()).subscribe((response: any) => {
        this.tableData = response.content;
        this.totalRecord = response.totalElements;

        if (this.paginator) {
          this.paginator.pageIndex = this.pagination.currentPage;
        }
      });
    } else {
      this._fetchData(this.filter.filterType); // Or reuse current filters if you have more
    }
  }

  changeStatus(status: boolean) {
    if (this.assignArray.length !== 0) {
      let params: any = {
        isDuplicate: false
      };
      let reqData = this.assignArray;
      this.patientService.assignPatient(reqData, params).pipe(first()).subscribe(
          (response: any) => {
            if (response != undefined) {
              this._fetchData();
              swal.fire({
                icon: 'success',
                text: 'Done',
                showConfirmButton: false,
                timer: 3000
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: response.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
      );
    } else {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: 'Please select at least one patient',
        showConfirmButton: false,
        timer: 5000
      });
    }

  }

  DeleteDuplicate(status: boolean) {
    if (this.assignArray.length !== 0) {
      let params: any = {
        isActive: status
      };
      let reqData = this.assignArray;
      this.patientService.assignPatient(reqData, params).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this._fetchData();
            swal.fire({
              icon: 'success',
              text: 'Done',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    } else {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: 'Please select at least one patient',
        showConfirmButton: false,
        timer: 5000
      });
    }

  }

  onSearch() {
    let inputValue = this.searchValue.nativeElement.value;

    if (inputValue !== '') {
      // Decode any URL-encoded characters like %20 to a normal string
      inputValue = decodeURIComponent(inputValue);

      // Use a regular expression to determine if the input looks like a date
      const isDateLike = this.isDateLike(inputValue);

      if (isDateLike) {
        // If it looks like a date, try formatting it
        this.formatDateString(inputValue);
      } else {
        // Otherwise, treat it as a normal search string
        this.searchString = inputValue;
        this.searchPatient();
      }
    } else {
      this.searchString = null;
      this._fetchData();
    }
  }

  handleKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onSearch();
      return;
    }

    // Existing debounce logic
    this.subject.next(value);
  }

  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.searchString = '';
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this._fetchData();
  }



// Helper function to check if a string looks like a date
  isDateLike(input: string): boolean {
    // Regular expression to check for common date patterns
    const datePattern = /^(\d{1,2}[-\/]\d{1,2}[-\/]\d{2,4})|(\d{4}[-\/]\d{1,2}[-\/]\d{1,2})|([A-Za-z]+\s\d{1,2},\s\d{4})$/;

    // Test the input against the date pattern
    return datePattern.test(input);
  }

  formatDateString(inputDate: string) {
    // Define possible date formats to parse the input date
    const formats = [
      'MM/dd/yyyy',
      'dd/MM/yyyy',
      'yyyy/MM/dd',
      'yyyy-MM-dd',
      'dd-MM-yyyy',
      'MM-dd-yyyy',
      'MMMM dd, yyyy',    // e.g., "October 15, 2024"
      'yyyy/MM/dd HH:mm',  // e.g., "2024/10/15 14:30"
      'MM/dd/yyyy HH:mm',  // e.g., "10/15/2024 14:30"
      'dd-MM-yyyy HH:mm',  // e.g., "15-10-2024 14:30"
    ];

    let parsedDate: Date | null = null;

    // Try parsing the input date with each format
    for (const formatStr of formats) {
      parsedDate = parse(inputDate, formatStr, new Date());
      if (isValid(parsedDate)) {
        break;  // Stop if a valid date is found
      }
    }

    // If a valid date was parsed, format it to 'MM/dd/yyyy'
    if (parsedDate && isValid(parsedDate)) {
      const formattedDate = format(parsedDate, 'MM/dd/yyyy');
      this.searchString = formattedDate; // Set the formatted date as the search string

      // Call the search function with the formatted date
      this.searchPatient();
    }
    // If no valid date is found, simply do nothing (no error message shown)
  }

  searchPatient() {
    let search: { [key: string]: any } = {
      page: 1,
      size: this.pagination.size,
      clientId: this.authService?.getClientId() ? this.authService.getClientId() : 1,
      planType: this.filter.planType,
      duplicate: true
    };
    if (this.searchString !== '' || this.searchString !== null || this.searchString !== undefined) {
      search.searchString = this.searchString;
    }
    if (this.sortField && this.sortDirection) {
      search.sort = `${this.sortField},${this.sortDirection}`;
    }
    this.patientService.searchPatient(search).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.tableData = response.content;
            //this.currentPage = response?.currentPage;
            this.totalRecord = response?.totalElements;
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message || 'something went wrong !',
            showConfirmButton: false,
            timer: 5000
          });
        }
    );

  }

  onPlanTypeToggle(type: 'PPO' | 'HMO') {
    if (this.selectedPlanType === type) return;

    this.selectedPlanType = type;
    this.filter.planType = type;

    // optional but recommended: reset listing to first page on toggle
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    if (this.paginator) this.paginator.pageIndex = 0;

    // persist filters if you want
    sessionStorage.setItem('patientDuplicateFilters', JSON.stringify(this.filter));

    this._fetchData(1);
  }


  // Get duplicate patient data
  _fetchData(type?: any) {
    this.assignArray = [];
    this.checked = false;

    let filterType = this.filter.filterType;

    let params: { [key: string]: any } = {
      page: this.pagination.page,
      size: this.pagination.size,
      clientId: this.authService.getClientId() || null,
      planType: this.filter.planType,
      isMultipleFilter: this.filter.isMultipleFilter,
      userTimeZone: this.filter.userTimeZone,
      duplicate: true
    };

    // ✅ Dates
    if (this.filter.startDate && this.filter.endDate) {
      params.apStartDate = this.formatStartOfDay(this.filter.startDate);
      params.apEndDate = this.formatEndOfDay(this.filter.endDate);
    }

    if (this.filter.wStartDate && this.filter.wEndDate) {
      params.woStartDate = this.formatStartOfDay(this.filter.wStartDate);
      params.woEndDate = this.formatEndOfDay(this.filter.wEndDate);
    }

    // ✅ Sort
    if (this.sortField && this.sortDirection) {
      params.sort = `${this.sortField},${this.sortDirection}`;
    }

    // ✅ Filters
    if (filterType === 1 && this.searchString?.trim()) {
      params.searchString = this.searchString.trim();
    }

    if (this.filter.status !== null) {
      params.status = this.filter.status;
    }

    if (this.filter.verification) {
      params.verification = this.filter.verification;
    }

    if (this.filter.agent !== null) {
      params.userId = this.filter.agent;
    }

    // ✅ Clean null/undefined
    Object.keys(params).forEach(key => {
      if (params[key] === undefined || params[key] === null) {
        delete params[key];
      }
    });

    sessionStorage.setItem('patientDuplicateFilters', JSON.stringify(this.filter));

    // ✅ API Call
    this.patientService.getAllPatients(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response) {
            const content = response.content || [];

            this.tableData = content;
            this.totalRecord = response.totalElements || content.length || 0;

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            // 🔥 FIX: force UI update immediately
            setTimeout(() => {
              this.cdr.detectChanges();
            }, 0);

          } else {
            this.tableData = [];
            this.totalRecord = 0;
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || response?.detail,
              showConfirmButton: false,
              timer: 5000
            });
          }

          this.isDropdownOpen = false;
        });
      },
      (error) => {
        this.tableData = [];
        this.totalRecord = 0;
        this.cdr.detectChanges();

        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error?.error?.message || '',
          showConfirmButton: false,
          timer: 5000
        });

        this.isDropdownOpen = false;
      }
    );
  }

  // Method to open the modal and add background blur
  openModal() {
    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'flex'; // Center modal with flexbox
    modalElement.classList.add('show'); // Add the 'show' class for animation

    // Add blur to the background
    this.renderer.addClass(document.body, 'blur-background');
  }

  // Method to close the modal and remove background blur
  closeModal() {
    this.errorMessages = null;
    this.errorMessagePart = null;
    this.files = null;       // Optionally clear the file data as well
    this.fileImage = null;
    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'none'; // Hide modal
    modalElement.classList.remove('show'); // Remove 'show' class

    // Remove blur from the background
    this.renderer.removeClass(document.body, 'blur-background');
  }

  handleErrorResponse(error: any): void {
    const errorMessage = error?.message;
    const errorArray = error?.errors;

    // Case 1: Error with 'errors' array (structured validation errors)
    if (errorArray && Array.isArray(errorArray)) {
      this.errorMessagePart = errorMessage || 'Validation errors occurred';
      this.errorMessages = errorArray.map((e: any) => e.message || 'Unknown validation error');
    }
    // Case 2: Error message with "Details:"
    else if (errorMessage && errorMessage.includes('Details:')) {
      const {messagePart, detailsPart} = this.extractErrorDetails(errorMessage);
      this.errorMessagePart = messagePart;
      this.errorMessages = detailsPart;
    }
    // Fallback: Just a plain message
    else if (errorMessage) {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Fallback : string
    else if (typeof errorMessage === 'string') {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Last fallback
    else {
      this.errorMessagePart = 'An error occurred';
      this.errorMessages = [];
    }
  }

  extractErrorDetails(message: string): { messagePart: string, detailsPart: string[] } {
    const detailsStart = message.indexOf('Details:');

    if (detailsStart === -1) {
      return {messagePart: message.trim(), detailsPart: []};
    }

    // Split the main message and the detailed part
    const messagePart = message.substring(0, detailsStart).trim();
    const detailsString = message.substring(detailsStart + 8).trim();

    const detailsPart: string[] = [];

    // Match all nested brackets: [row: 1, ...], [row: 2, ...]
    const nestedDetailMatches = detailsString.match(/\[(.*?)\]/g); // Match all [ ... ] groups

    if (nestedDetailMatches) {
      nestedDetailMatches.forEach(detail => {
        const cleanDetail = detail
            .replace(/^\[|\]$/g, '') // remove outer brackets
            .trim();
        if (cleanDetail) {
          detailsPart.push(cleanDetail);
        }
      });
    } else {
      // Fallback if no brackets are found: split by comma
      detailsPart.push(...detailsString.split(',').map(d => d.trim()));
    }

    return {messagePart, detailsPart};
  }


  // pagination changes
  pageChange(event: any) {
    this.pagination.currentPage = event.pageIndex;
    this.pagination.page = this.pagination.currentPage + 1;
    this.pagination.size = event.pageSize;

    sessionStorage.setItem('patientDuplicatesPagination', JSON.stringify(this.pagination));
    sessionStorage.setItem('patientDuplicateFilters', JSON.stringify(this.filter))

    this._fetchData(); // Fetch data using selectedType
  }

  loadPaginationState() {
    const storedData = sessionStorage.getItem('patientDuplicatesPagination');
    const storedFilter = sessionStorage.getItem('patientDuplicateFilters');

    if (storedData) {
      this.pagination = JSON.parse(storedData);

    }
    if(storedFilter){
      this.filter = JSON.parse(storedFilter)
    }
  }

  sortData(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction === '' ? null : sort.direction;
    // Fetch sorted data from the backend for other fields
    this._fetchData();
  }

  logout() {
    // Clear session storage during logout
    sessionStorage.removeItem('patientDuplicatesPagination');
    sessionStorage.removeItem('patientDuplicateFilters')
    this.authService.logout();
  }


  // ngOnDestroy(): void {
  //     // Clear session storage when the component is destroyed
  //     // sessionStorage.removeItem('patientPagination');
  // }

  private _setSearchSubscription(): void {
    this.subject.pipe(
        debounceTime(200)
    ).subscribe((searchValue: any) => {
      if (this.searchValue.nativeElement.value === '') {
        this.onSearch();
      }
    });
  }

  trackByPatientId(index: number, item: any): any {
    return item && item.id != null ? item.id : index;
  }

  trackByAgentId(index: number, agent: any): any {
    return agent && agent.id != null ? agent.id : index;
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
